// تمام ثابت‌ها با برچسب‌های فارسی و رنگ‌بندی

export const AGE_GROUP_LABELS = {
  NOONAL: 'نونهالان',
  NOJAVAN: 'نوجوانان',
  JAVAN: 'جوانان',
  OMID: 'امید',
  BOZORGSAL: 'بزرگسالان',
};

export const GENDER_LABELS = {
  MALE: 'مرد',
  FEMALE: 'زن',
};

export const PLAYER_STATUS_LABELS = {
  PENDING: 'در انتظار تایید',
  ACTIVE: 'فعال',
  REJECTED: 'رد شده',
  INACTIVE: 'غیرفعال',
  INJURED: 'مصدوم',
};

export const PLAYER_STATUS_COLORS = {
  PENDING: 'bg-amber-100 text-amber-700',
  ACTIVE: 'bg-emerald-100 text-emerald-700',
  REJECTED: 'bg-red-100 text-red-700',
  INACTIVE: 'bg-slate-100 text-slate-500',
  INJURED: 'bg-orange-100 text-orange-700',
};

export const PREFERRED_FOOT_LABELS = {
  RIGHT: 'راست‌ پا',
  LEFT: 'چپ‌ پا',
  BOTH: 'دو پا',
};

export const PLAYER_LEVEL_LABELS = {
  AMATEUR: 'آماتور',
  ACADEMY: 'آکادمی',
  PROFESSIONAL: 'حرفه‌ای',
  NATIONAL: 'ملی',
};

export const BLOOD_TYPE_LABELS = {
  A_POSITIVE: 'A+',
  A_NEGATIVE: 'A-',
  B_POSITIVE: 'B+',
  B_NEGATIVE: 'B-',
  AB_POSITIVE: 'AB+',
  AB_NEGATIVE: 'AB-',
  O_POSITIVE: 'O+',
  O_NEGATIVE: 'O-',
};

export const MATCH_TYPE_LABELS = {
  FOOTBALL: 'فوتبال',
  FUTSAL: 'فوتسال',
  BEACH: 'ساحلی',
};

export const MATCH_STATUS_LABELS = {
  SCHEDULED: 'برنامه‌ریزی‌ شده',
  PLAYED: 'برگزار شده',
  CANCELED: 'لغو شده',
  POSTPONED: 'به تعویق افتاده',
};

export const MATCH_STATUS_COLORS = {
  SCHEDULED: 'bg-blue-100 text-blue-700',
  PLAYED: 'bg-emerald-100 text-emerald-700',
  CANCELED: 'bg-red-100 text-red-700',
  POSTPONED: 'bg-amber-100 text-amber-700',
};

export const TOURNAMENT_TYPE_LABELS = {
  LEAGUE: 'لیگ',
  CUP: 'جام حذفی',
  FRIENDLY: 'دوستانه',
  TRAINING: 'تمرینی',
};

export const TOURNAMENT_STATUS_LABELS = {
  OPEN: 'باز برای ثبت‌ نام',
  ONGOING: 'در حال برگزاری',
  COMPLETED: 'پایان‌ یافته',
  CLOSED: 'بسته شده',
};

export const STAGE_TYPE_LABELS = {
  GROUP: 'گروهی',
  KNOCKOUT: 'حذفی',
};

export const TOURNAMENT_STATUS_COLORS = {
  OPEN: 'bg-emerald-100 text-emerald-700',
  ONGOING: 'bg-blue-100 text-blue-700',
  COMPLETED: 'bg-slate-100 text-slate-500',
  CLOSED: 'bg-red-100 text-red-700',
};

export const REGISTRATION_STATUS_LABELS = {
  PENDING: 'در انتظار تایید',
  APPROVED: 'تاییدشده',
  REJECTED: 'رد شده',
};

export const REGISTRATION_STATUS_COLORS = {
  PENDING: 'bg-amber-100 text-amber-700',
  APPROVED: 'bg-emerald-100 text-emerald-700',
  REJECTED: 'bg-red-100 text-red-700',
};

export const PAYMENT_STATUS_LABELS = {
  UNPAID: 'پرداخت نشده',
  PAID: 'پرداخت شده',
  REFUNDED: 'بازگشت داده شده',
};

export const PAYMENT_STATUS_COLORS = {
  UNPAID: 'bg-red-100 text-red-700',
  PAID: 'bg-emerald-100 text-emerald-700',
  REFUNDED: 'bg-slate-100 text-slate-500',
};

export const TICKET_PRIORITY_LABELS = {
  LOW: 'کم',
  MEDIUM: 'متوسط',
  HIGH: 'بالا',
};

export const TICKET_PRIORITY_COLORS = {
  LOW: 'bg-slate-100 text-slate-500',
  MEDIUM: 'bg-blue-100 text-blue-700',
  HIGH: 'bg-red-100 text-red-700',
};

export const TICKET_STATUS_LABELS = {
  OPEN: 'باز',
  IN_PROGRESS: 'در حال بررسی',
  CLOSED: 'بسته‌ شده',
};

export const TICKET_STATUS_COLORS = {
  OPEN: 'bg-blue-100 text-blue-700',
  IN_PROGRESS: 'bg-amber-100 text-amber-700',
  CLOSED: 'bg-slate-100 text-slate-500',
};

export const POST_TYPE_LABELS = {
  NEWS: 'خبر',
  EVENT: 'رویداد',
  BLOG: 'وبلاگ',
  ARTICLE: 'مقاله',
  ANNOUNCEMENT: 'اطلاعیه',
};

export const POST_STATUS_LABELS = {
  DRAFT: 'پیش‌ نویس',
  REVIEW: 'در بررسی',
  PUBLISHED: 'منتشرشده',
  ARCHIVED: 'بایگانی‌ شده',
};

export const POST_STATUS_COLORS = {
  DRAFT: 'bg-slate-100 text-slate-500',
  REVIEW: 'bg-amber-100 text-amber-700',
  PUBLISHED: 'bg-emerald-100 text-emerald-700',
  ARCHIVED: 'bg-slate-200 text-slate-600',
};

export const AD_TYPE_LABELS = {
  BANNER: 'بنر',
  SLIDER: 'اسلایدر',
  POPUP: 'پاپ‌آپ',
  SIDEBAR: 'سایدبار',
  VIDEO: 'ویدئو',
};

export const AD_STATUS_LABELS = {
  ACTIVE: 'فعال',
  EXPIRED: 'منقضی‌ شده',
  PAUSED: 'متوقف‌ شده',
};

export const AD_STATUS_COLORS = {
  ACTIVE: 'bg-emerald-100 text-emerald-700',
  EXPIRED: 'bg-slate-100 text-slate-500',
  PAUSED: 'bg-amber-100 text-amber-700',
};

export const TRANS_TYPE_LABELS = {
  INCOME: 'درآمد',
  EXPENSE: 'هزینه',
};

export const TRANSFER_TYPE_LABELS = {
  PERMANENT: 'قطعی',
  LOAN: 'قرضی',
  FREE: 'آزاد',
  RETURN_FROM_LOAN: 'بازگشت از قرضی',
};

export const TRANSFER_TYPE_COLORS = {
  PERMANENT: 'bg-emerald-100 text-emerald-700',
  LOAN: 'bg-blue-100 text-blue-700',
  FREE: 'bg-slate-100 text-slate-600',
  RETURN_FROM_LOAN: 'bg-amber-100 text-amber-700',
};

export const TRANS_STATUS_LABELS = {
  PENDING: 'در انتظار تایید',
  CONFIRMED: 'تاییدشده',
  REJECTED: 'رد شده',
};

export const TRANS_STATUS_COLORS = {
  PENDING: 'bg-amber-100 text-amber-700',
  CONFIRMED: 'bg-emerald-100 text-emerald-700',
  REJECTED: 'bg-red-100 text-red-700',
};

export const REPORT_TYPE_LABELS = {
  CLUB_STATUS: 'وضعیت باشگاه‌ها',
  MATCH_SUMMARY: 'خلاصه مسابقات',
  FINANCIAL: 'گزارش مالی',
  PLAYER_LIST: 'لیست بازیکنان',
};

export const STAFF_ROLE_LABELS = {
  PRESIDENT: 'رئیس',
  CEO: 'مدیرعامل',
  MANAGER: 'مدیر',
  COACH: 'مربی',
  ASSISTANT_COACH: 'مربی کمک',
  FITNESS_COACH: 'مربی بدنساز',
  DOCTOR: 'پزشک',
  ANALYST: 'تحلیل‌ گر',
  MEDIA_MANAGER: 'مدیر رسانه',
};

export const CONTRACT_STATUS_LABELS = {
  ACTIVE: 'فعال',
  EXPIRED: 'منقضی‌ شده',
  TERMINATED: 'فسخ شده',
};

export const INJURY_STATUS_LABELS = {
  ACTIVE: 'در حال درمان',
  RECOVERED: 'بهبود یافته',
};

export const CLUB_STATUS_LABELS = {
  PENDING: 'در انتظار تایید',
  ACTIVE: 'فعال',
  INACTIVE: 'غیرفعال',
  SUSPENDED: 'معلق',
};

export const CLUB_STATUS_COLORS = {
  PENDING: 'bg-amber-100 text-amber-700',
  ACTIVE: 'bg-emerald-100 text-emerald-700',
  INACTIVE: 'bg-slate-100 text-slate-500',
  SUSPENDED: 'bg-red-100 text-red-700',
};

export const USER_ROLE_LABELS = {
  ADMIN: 'مدیر کل',
  CLUB_MANAGER: 'مدیر باشگاه',
  REFEREE: 'داور',
  OBSERVER: 'ناظر',
};

export function formatCurrency(amount) {
  return Number(amount || 0).toLocaleString('fa-IR') + ' تومان';
}

export const POSITION_TYPE_LABELS = {
  BOARD: 'هیئت رئیسه',
  COMMITTEE: 'کمیته',
};

export const POSITION_STATUS_LABELS = {
  ACTIVE: 'فعال',
  INACTIVE: 'غیرفعال',
  EXPIRED: 'منقضی',
};

export const POSITION_STATUS_COLORS = {
  ACTIVE: 'bg-emerald-100 text-emerald-700',
  INACTIVE: 'bg-slate-100 text-slate-500',
  EXPIRED: 'bg-amber-100 text-amber-700',
};

// ===== پست‌های فوتبال =====
export const POSITIONS = [
  { value: 'GK', label: 'دروازه‌ بان' },
  { value: 'RB', label: 'دفاع راست' },
  { value: 'LB', label: 'دفاع چپ' },
  { value: 'CB', label: 'مدافع میانی' },
  { value: 'RWB', label: 'وینگ‌ بک راست' },
  { value: 'LWB', label: 'وینگ‌ بک چپ' },
  { value: 'CDM', label: 'هافبک دفاعی' },
  { value: 'CM', label: 'هافبک مرکزی' },
  { value: 'CAM', label: 'هافبک هجومی' },
  { value: 'RM', label: 'هافبک راست' },
  { value: 'LM', label: 'هافبک چپ' },
  { value: 'RW', label: 'وینگر راست' },
  { value: 'LW', label: 'وینگر چپ' },
  { value: 'ST', label: 'مهاجم نوک' },
  { value: 'CF', label: 'مهاجم دوم' },
  { value: 'SS', label: 'مهاجم مکمل' },
];
export const TRANSFER_REQUEST_STATUS_LABELS = {
  PENDING: 'در انتظار تصمیم',
  APPROVED: 'تأیید شده',
  REJECTED: 'رد شده',
  CANCELED: 'لغو شده',
};

export const TRANSFER_REQUEST_STATUS_BADGE = {
  PENDING: 'pending',
  APPROVED: 'active',
  REJECTED: 'suspended',
  CANCELED: 'inactive',
};
